import axios from '../../utils/axios';
import { BAD_REQUEST, INTERNAL_SERVER_ERROR, OK } from '../../constants/http';

const getProjectsWithEvaluations = async ({
  searchValue, userId, cycleId,
}) => {
  try {
    const { data } = await axios.get(
      `/api/performance-aspects/projects/${userId}/${cycleId}?&searchValue=${searchValue}`,
    );

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const errStatus = err.response
      ? err.response.status
      : INTERNAL_SERVER_ERROR.status;
    const message = err.response
      ? err.response.statusText
      : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status: errStatus,
      message,
      data: {
        errorMessage:
          'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const getUserEvaluations = async ({
  userId, cycleId,
}) => {
  try {
    const { data } = await axios.get(
      `/api/performance-aspects/evaluations/${userId}/${cycleId}`,
    );

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const errStatus = err.response
      ? err.response.status
      : INTERNAL_SERVER_ERROR.status;
    const message = err.response
      ? err.response.statusText
      : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status: errStatus,
      message,
      data: {
        errorMessage:
          'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const editEvaluation = async ({
  evaluationId, evaluation, comment, notApplicable,
}) => {
  try {
    const response = await axios.put(`/api/performance-aspects/evaluations/${evaluationId}`, {
      evaluation,
      comment,
      notApplicable,
    });
    if (response.data.success) {
      return {
        success: true,
        status: OK.status,
        message: OK.message,
        data: response.data,
      };
    }

    return {
      success: false,
      status: BAD_REQUEST.status,
      message: response.data.data.errorMessage,
      data: {},
    };
  } catch (err) {
    const errStatus = err.response
      ? err.response.status
      : INTERNAL_SERVER_ERROR.status;
    const message = err.response
      ? err.response.statusText
      : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status: errStatus,
      message,
      data: {
        errorMessage:
          'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const postBulkUploadPerformanceAspects = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post('/api/performance-aspects/bulk-upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response.data.success) {
      return {
        success: true,
        status: OK.status,
        message: OK.message,
        data: response.data,
      };
    }

    return {
      success: false,
      status: BAD_REQUEST.status,
      message: response.data.data?.errorMessage || 'Error al cargar el archivo',
      data: response.data,
    };
  } catch (err) {
    const errStatus = err.response
      ? err.response.status
      : INTERNAL_SERVER_ERROR.status;
    const message = err.response
      ? err.response.data.data?.errorMessage
      : INTERNAL_SERVER_ERROR.message;

    return {
      success: false,
      status: errStatus,
      message,
      data: {
        errorMessage:
          'Ha ocurrido un error al cargar el archivo. Por favor intente nuevamente.',
      },
    };
  }
};

export default {
  getProjectsWithEvaluations,
  getUserEvaluations,
  editEvaluation,
  postBulkUploadPerformanceAspects,
};
